import { render } from "./VacunaPersTabla02.vue?vue&type=template&id=763a95cc&scoped=true"
import script from "./VacunaPersTabla02.vue?vue&type=script&lang=js"
export * from "./VacunaPersTabla02.vue?vue&type=script&lang=js"

import "./VacunaPersTabla02.vue?vue&type=style&index=0&id=763a95cc&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763a95cc"]])

export default __exports__